import { Row } from './row';
import { BaseUIElement } from './baseUIElement';
import { CSS } from '../../../const';
import { IUIElementOptions } from '../../../interfaces/options';
import { Templates } from '../../../compile';

export class Group extends Row {
	constructor(
		id: string,
		label: string,
		uiElements?: BaseUIElement[] | KnockoutObservableArray<BaseUIElement>,
		options?: IUIElementOptions
	) {
		options = $.extend(
			true,
			{},
			<IUIElementOptions>{
				template: Templates.layouts_uiElements_group
			},
			options || {}
		);
		super(id, label, uiElements, options);
		this.css = ko.pureComputed(() => {
			var css = CSS.Group.concat(' ', CSS.CellX.concat(this.size()));
			if (options.css) {
				return css.concat(' ', typeof options.css === "string" ? options.css : options.css());
			}
			return css;
		});
	}
}
